<cdx-wapple-loading *ngIf="isLoading$ | async"></cdx-wapple-loading>
<ng-container *ngIf="recipe$ | async; let recipe">
  <recipe-seo [recipe]="recipe"></recipe-seo>
  <div class="recipeDetails-section recipeDetails-section--white">
    <recipe-details-header
      [id]="recipe.id"
      [title]="recipe.title"
      [description]="recipe.description"
      [imageUrl]="recipe.largeImageFilename"
      [mealTimes]="recipe.mealtimes?.split(',') || []"
      [prepDuration]="recipe.prepDuration"
      [cookDuration]="recipe.cookingDuration"
      [servings]="recipe.servings"
      [saved]="recipeSaved$ | async"
      [saveButtonState]="saveButtonState$ | async"
      [nutritionTags]="recipe.nutritionTags"
      [isMealPlanningContext]="isMealPlanningContext"
      [isAddedToMealPlan]="isAddedToMealPlan$ | async"
      [isMealPlanningEnabled]="isMealPlanningEnabled$ | async"
      (save)="handleSave()"
      (addToMealPlan)="handleAddToMealPlan()"
      (viewMealPlan)="handleViewMealPlan()"
    ></recipe-details-header>
  </div>
  <div class="recipeDetails-section recipeDetails-section--white">
    <recipe-method
      [id]="recipe.id"
      [title]="recipe.title"
      [servings]="recipe.servings"
      [method]="recipe.instructions"
      [ingredients]="recipe.ingredients"
      [contributorLink]="recipe.webpageLink"
      [contributorName]="recipe.contributorName"
      [contributorTown]="recipe.contributorTown"
      [modalOutletName]="modalOutletName"
      [enableAddToTrolley]="recipe.enableAddToTrolley && (enableAddToTrolley$ | async)"
    ></recipe-method>
  </div>
  <ng-container *ngIf="relatedRecipes$ | async; let relatedRecipes">
    <div *ngIf="relatedRecipes.length === 3" class="recipeDetails-youMightLike">
      <h2 i18n="@@recipeDetails-youMightLike">You might also like</h2>
      <recipe-grid-container [placeholders]="3" mode="carousel" [recipes]="relatedRecipes"></recipe-grid-container>
      <a
        cdxButton
        [routerLink]="landingPageRoute"
        (click)="seeMoreRecipesClick()"
        i18n="@@recipeDetails-seeMoreRecipes"
        [inline]="true"
        >See more Recipes</a
      >
    </div>
  </ng-container>
</ng-container>
<router-outlet name="recipe-modal"></router-outlet>